import classNames from 'classnames';
import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import { createPrefixCls } from '../_utils/string';
import Icon from '../icon';
import Modal from '../modal';
import Upload from './upload';
const prefixCls = createPrefixCls('upload-list');
export const UploadList = ({ files: propFiles, circle, radius, max, onChange }) => {
    const [files, setFiles] = useState(propFiles || []);
    const [itemHeight, setItemHeight] = useState();
    const $item = useRef();
    useEffect(() => {
        if ($item.current) {
            setItemHeight($item.current.offsetWidth);
        }
    }, []);
    useEffect(() => {
        if (propFiles) {
            setFiles([...propFiles]);
        }
    }, [propFiles]);
    const handleDone = useCallback(({ data }) => {
        const fileList = [...files, data];
        if (!propFiles) {
            setFiles(fileList);
        }
        onChange && onChange(fileList);
    }, [files, onChange, propFiles]);
    const handleDelete = useCallback((index) => {
        return () => {
            Modal.confirm({
                title: '确认删除此图片吗',
                onOk: () => {
                    const fileList = [...files.filter((_file, i) => i !== index)];
                    setFiles(fileList);
                    onChange && onChange(fileList);
                }
            });
        };
    }, [files, onChange]);
    const disabled = useMemo(() => {
        return !!(max && files.length >= max);
    }, [files.length, max]);
    const imgCls = useMemo(() => {
        return classNames(prefixCls('img'), circle && prefixCls('circle'));
    }, [circle]);
    const imgSty = useMemo(() => {
        return {
            borderRadius: radius
        };
    }, [radius]);
    return (React.createElement("div", { className: prefixCls() },
        files.map((file, index) => {
            return (React.createElement("div", { key: `${file}${Date.now()}`, className: prefixCls('item'), style: { height: itemHeight } },
                React.createElement("img", { className: imgCls, style: imgSty, src: file }),
                React.createElement("div", { className: prefixCls('delete'), onClick: handleDelete(index) })));
        }),
        React.createElement(Upload, { disabled: disabled, onDone: handleDone },
            React.createElement("div", { ref: $item, className: prefixCls('item'), style: { height: itemHeight } },
                React.createElement("div", { className: prefixCls('add') }, disabled ? (React.createElement("span", { className: prefixCls('add-tip') },
                    "\u6700\u591A\u6DFB\u52A0",
                    max,
                    "\u5F20",
                    React.createElement("br", null),
                    "\u5DF2\u8FBE\u6DFB\u52A0\u4E0A\u9650")) : (React.createElement(Icon, { name: "add", className: prefixCls('add-icon') })))))));
};
export default UploadList;
